import React from 'react';
import { Result } from 'antd';
import { useAuthStore } from '@/store/authStore';

const OperatorRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { authorization } = useAuthStore();
  const allowed = !!authorization && authorization.actions.includes('transfers.adhoc');
  if (!allowed) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="You need the Operator role to trigger ad hoc transfers."
      />
    );
  }
  return <>{children}</>;
};

export default OperatorRoute;
